export default __webpack_public_path__ + "static/media/MR.8f3d6c55.png";